import React from "react"

import TokenList from "decentraland-gatsby/dist/utils/dom/TokenList"

import "./Close.css"

export type CloseProps = React.SVGAttributes<SVGElement> & {
  dark?: boolean
}

export const Close = React.memo(function (props: CloseProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      className={TokenList.join([
        "icon-close",
        props.className,
        props.dark && "dark",
      ])}
    >
      <g fill="none" fillRule="evenodd">
        <path d="M8 0C12.4184 0 16 3.5816 16 8C16 12.4184 12.4184 16 8 16C3.5816 16 0 12.4184 0 8C0 3.5816 3.5816 0 8 0ZM6.3032 5.1712C6.15957 5.0262 5.96594 4.94157 5.76196 4.93465C5.55798 4.92773 5.35907 4.99904 5.20594 5.13397C5.05281 5.26891 4.95704 5.45727 4.93824 5.6605C4.91944 5.86373 4.97902 6.06646 5.1048 6.2272L5.172 6.3032L6.868 7.9992L5.172 9.6968C5.027 9.84043 4.94237 10.0341 4.93545 10.238C4.92853 10.442 4.99984 10.6409 5.13477 10.7941C5.26971 10.9472 5.45807 11.043 5.6613 11.0618C5.86453 11.0806 6.06726 11.021 6.228 10.8952L6.3032 10.8288L8 9.1312L9.6968 10.8288C9.84043 10.9738 10.0341 11.0584 10.238 11.0653C10.442 11.0723 10.6409 11.001 10.7941 10.866C10.9472 10.7311 11.043 10.5427 11.0618 10.3395C11.0806 10.1363 11.021 9.93354 10.8952 9.7728L10.8288 9.6968L9.1312 8L10.8288 6.3032C10.9738 6.15957 11.0584 5.96594 11.0653 5.76196C11.0723 5.55798 11.001 5.35907 10.866 5.20594C10.7311 5.05281 10.5427 4.95704 10.3395 4.93824C10.1363 4.91944 9.93354 4.97902 9.7728 5.1048L9.6968 5.1712L8 6.8688L6.3032 5.1712Z"></path>
      </g>
    </svg>
  )
})
